import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { DoctorService } from '../../services/doctor.service';
import { Appointment } from '../../classes/appointment.interface';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit {
  action: any;
  msg1: string;
  utime: any;
  photo = [];
  doctorname = [];
  doctor: any;
  uid: any;
  appointment: Appointment[];
  public loading = false;
  found = 1;
  constructor(private commonService: CommonService, private doctorService: DoctorService,
    private snackbar: MatSnackBar) {
  const udata = this.commonService.getUserDataLocally();
  this.uid = udata.uid;
  }
  ngOnInit() {
    this.getMyAppointment();
    this.getTime();
  }
  getTime() {
    this.doctorService.getTime()
    .subscribe(
      (d) => {
        const ctime = d.date;
        const css = moment(ctime.date);
        const cs =  moment.utc(css);
        this.utime = moment(cs, 'MM-DD-YYYY hh:mm:ss').unix() * 1000;
      });
  }
  getMyAppointment() {
    this.loading = true;
 this.doctorService.getUserAppointment(this.uid)
 .subscribe(
  (x: Appointment[]) => {
    this.loading = false;
    this.appointment = x;
    if(this.appointment && this.appointment.length > 0){
      this.found = 1;
    } else {
      this.found = 0;
    }
    for (let i = 0 ; i < this.appointment.length ; i++ ) {
      this.getServiceprovidername(this.appointment[i].serviceprovider_id)
    }
  });
  }
  getServiceprovidername(sid) {
    this.doctorService.getDoctorsDetail(sid)
    .subscribe(
      (x) => {
        this.doctor = x;
        this.doctorname['id' + this.doctor[0].id] = this.doctor[0].name;
        this.photo['id' + this.doctor[0].id] = this.doctor[0].photo;
    });
  }

  iscancellable(dat , stime) {
    const converstime = moment(dat + '/'  + stime);
    const cs = moment.utc(converstime);
    const uti = moment(cs, 'MM-DD-YYYY hh:mm:ss').unix() * 1000;
    return uti;
   }
   cancelAppointment(apid, dat , stime) {
     this.loading = true;
     const nt = this.iscancellable( dat , stime)
     this.doctorService.getTime()
     .subscribe(
       (d) => {
         const ctime = d.date;
         const css = moment(ctime.date);
         const cs =  moment.utc(css);
         this.utime = moment(cs, 'MM-DD-YYYY hh:mm:ss').unix() * 1000;
         this.checkPosibility(nt,apid);
       });
  }
  checkPosibility(nt , apid) {
    if (nt > this.utime) {
      this.cancellFinally(apid);
    }else {
      this.loading = false;
      this.msg1 = 'Cancellation not possible';
      this.openSnackBar();
    }
  }
  cancellFinally(apid) {
    this.doctorService.cancellAppointment(apid)
    .subscribe (
      (x) => {
        this.getMyAppointment();
        this.msg1 = 'Appointment Cancelled Successfully';
        this.loading = false;
        this.openSnackBar();
      }
    );
  }
  openSnackBar() {
    this.snackbar.open(this.msg1 , this.action, {
      duration: 4000,
    });
  }
}
